/**
 * useStudentAssessmentsData — la lecture de « Mes contrôles » : `getSchoolAssessments` pour
 * l'élève connecté, les seuls contrôles à venir (`{ student_id, upcoming: true }`), une fois par
 * élève au montage et à chaque relecture — comme `SchoolAssessmentsScreen.js`.
 *
 * Patron A : la réponse arrive par le réducteur (`schoolAssessments.byStudentId`), que l'accueil et
 * « Générer une activité » lisent aussi. La tranche n'est pas consommée ici : le view-model y lit
 * seulement l'attente et l'erreur.
 */
import { useCallback, useEffect, useRef } from "react"
import { useDispatch } from "react-redux"

import { apiRequest } from "../../../../../../data/redux/actions/api"
import { schoolAssessmentsService } from "../../../../../../data/services/schoolAssessmentsService"

export function useStudentAssessmentsData(studentId: string | number | null) {
    const dispatch = useDispatch()
    const lastFetchedRef = useRef<string | number | null>(null)

    const refresh = useCallback(() => {
        if (studentId == null) return
        dispatch(
            apiRequest(
                schoolAssessmentsService.getSchoolAssessments,
                {},
                {},
                { student_id: studentId, upcoming: true }
            ) as never
        )
    }, [dispatch, studentId])

    useEffect(() => {
        if (studentId == null || lastFetchedRef.current === studentId) return
        lastFetchedRef.current = studentId
        refresh()
    }, [refresh, studentId])

    return { refresh }
}
